<!-- 地图左上角的农机品目类型选择器 -->
<template>
  <dl class="vehicle-models-selecter" v-toggle="{ closeWhenSelected }">
    <dt :title="`已选农机品类：${currentVehicleModelName}`">
      <span>{{ currentVehicleModelName }}</span>
    </dt>
    <dd>
      <ul>
        <li @click="toggleSelected(item)" :class="{ disabled: item.disabled, selected: item.selected }" :style="`--icon: url(/images/weather/p${item.code}001.png)`" :key="`${i}.${item.code}`" v-for="(item, i) in categories">
          <span :title="item.label">{{ item.label || `编号为${item.code || '未知'}的预警` }}</span>
        </li>
      </ul>
    </dd>
  </dl>
</template>

<script>
export default {
  name: 'vehicleModelsSelecter',
  props: {
    // [{ label: '收获类机械', code: '0001', disabled: 0, selected: false, count: 11 },]
    value: {
      type: [String, Number],
      default: null,
    },
    list: {
      type: Array,
      default: () => [],
    },
    // 选择后是否关闭下拉列表
    closeWhenSelected: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      v: null,
      categories: [],
    };
  },
  computed: {
    currentVehicleModelName() {
      let self = this;
      // console.log('%cvehicleModelsSelecter.computed.currentVehicleModelName', 'color:#CC0', { v: self.v, value: self.value, list: self.list });
      const name = self.list.find((v) => v.code == self.v)?.label || '全部';
      return name;
    },
  },
  watch: {
    value: {
      handler(v) {
        let self = this;
        self.v = v;
      },
      immediate: true,
    },
    list: {
      handler(val) {
        this.categories = val;
      },
      immediate: true,
    },
  },
  methods: {
    toggleSelected(item) {
      let self = this;
      const current = self.categories.find((v) => v.code === item.code);
      self.categories.forEach((v, i) => {
        if (v.code === item.code && !v.disabled) {
          self.$set(self.categories, i, { ...v, selected: !v.selected });
        } else {
          if (!v.disabled) {
            self.$set(self.categories, i, { ...v, selected: false });
          }
        }
      });
      const categories = self.categories;
      // console.log('toggleSelected', categories);
      self.$emit('input', current && current.code);
      self.$emit('changed', categories);
    },
  },
  directives: {
    // 点击dt，切换dd的显示状态，点击页面空白处后收起dt
    toggle: {
      inserted(el, binding) {
        console.log('toggle mounted', el, binding);
        const dt = el.querySelector('dt');
        const dd = el.querySelector('dd');

        // 初始状态设置为隐藏
        dd.style.display = 'none';
        dd.style.overflow = 'hidden';

        // 计算vh值
        const calculateVH = (px) => {
          return (px / 1080) * window.innerHeight + 'px';
        };

        // 点击dt切换显示状态
        dt.addEventListener('click', (e) => {
          e.stopPropagation();
          if (dd.style.display === 'none') {
            dd.style.height = '0';
            dd.style.display = 'block';
            requestAnimationFrame(() => {
              dd.style.height = calculateVH(281);
              dd.style.transition = 'height 0.1s ease-in-out';
            });
          } else {
            dd.style.height = '0';
            dd.style.transition = 'height 0.1s ease-in-out';
            setTimeout(() => {
              dd.style.display = 'none';
            }, 100);
          }
          dt.classList.toggle('active');
        });

        // 点击dd中的li
        dd.addEventListener('click', (e) => {
          e.stopPropagation();
          if (binding.value.closeWhenSelected) {
            dd.style.display = 'none';
            dt.classList.remove('active');
          }
        });

        // 点击页面其他地方关闭
        const handleClickOutside = (e) => {
          if (!el.contains(e.target) && dd.style.display !== 'none') {
            dd.style.height = '0';
            dd.style.transition = 'height 0.1s ease-in-out';
            setTimeout(() => {
              dd.style.display = 'none';
            }, 100);
          }
        };

        // 监听窗口大小变化，更新高度
        const updateHeight = () => {
          if (dd.style.display !== 'none') {
            dd.style.height = calculateVH(281);
          }
        };
        window.addEventListener('resize', updateHeight);

        // 添加点击事件监听
        document.addEventListener('click', handleClickOutside);

        // 清理事件监听
        el._cleanup = () => {
          document.removeEventListener('click', handleClickOutside);
          window.removeEventListener('resize', updateHeight);
        };
      },
      unbind(el) {
        // 组件销毁时清理事件监听
        el._cleanup && el._cleanup();
      },
    },
  },
};
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 1920) * 100vw;
}
@function vh($px) {
  @return ($px / 1080) * 100vh;
}
@function fontSize($px) {
  @return 100vw * $px / 1920;
}
@mixin line($count: 1) {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: $count;
  overflow: hidden;
  text-overflow: ellipsis;
  word-wrap: break-word;
  hyphens: auto;
}
%scrollbar {
  overflow: auto;

  &::-webkit-scrollbar {
    width: vh(4);
    height: vh(4);
  }

  &::-webkit-scrollbar-track {
    // background: rgba(10, 77, 19, 0.2);
    background: transparent;
    border-radius: vh(4);
  }

  &::-webkit-scrollbar-thumb {
    background: #00af6f;
    border-radius: vh(20);
  }

  &::-webkit-scrollbar-thumb:hover {
    background: rgba(48, 234, 168, 0.8);
  }

  &::-webkit-scrollbar-corner {
    background: rgba(48, 234, 168, 0.6);
  }
}
dl.vehicle-models-selecter {
  position: relative;
  margin: 0;
  padding: 0;
  user-select: none;
  dt {
    width: vw(150);
    height: vh(39);
    padding: vw(4) 0 0 vw(9);
    line-height: vh(35);
    font-size: fontSize(16);
    background: url(../images/btn_vehicle_models.png) no-repeat left top;
    background-size: 100% 100%;
    cursor: pointer;
    position: absolute;
    left: 0;
    top: 0;
    color: #30eca9;
    &::after {
      content: '';
      display: inline-block;
      width: 0;
      height: 0;
      border-bottom: vh(8) solid #30eca9;
      border-left: vw(6) solid transparent;
      border-right: vw(6) solid transparent;
      border-top: vh(8) solid transparent;
      position: absolute;
      right: vw(10);
      top: vh(10);
    }
    &.active::after {
      border-top: vh(8) solid #30eca9;
      border-bottom: vh(8) solid transparent;
      top: vh(20);
    }
    &:hover {
      color: #2ed399;
    }
    &:active {
      span {
        position: relative;
        left: 1px;
        top: 1px;
      }
    }
    span {
      display: inline-block;
      width: vw(112);
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
  dd {
    position: absolute;
    left: 0;
    top: vh(50);
    background: hsla(141, 75%, 15%, 0.8);
    width: vw(149);
    padding: 0;
    margin: 0;
    overflow: hidden;
    transition: height 0.1s ease-in-out;
    // box-shadow: vh(5) vh(5) vh(10) 0 rgba(0, 0, 0, 0.5);
    // border-radius: vh(3);
    backdrop-filter: blur(2px);
    ul {
      list-style: none;
      padding: 0;
      margin: 0;
      overflow: auto;
      height: 100%;
      @extend %scrollbar;
      li {
        height: vh(40);
        line-height: vh(40);
        font-size: fontSize(16);
        font-weight: bold;
        color: #62d9ad;
        padding: 0 vw(9);
        cursor: pointer;
        white-space: nowrap;
        overflow: hidden;
        @include line(2);
        &.disabled {
          cursor: not-allowed;
          color: #ffffff99;
        }
        &.selected,
        &.selected:hover {
          background-color: #14bb7f;
          color: #fff;
        }
        &:hover {
          background-color: hsla(158, 81%, 41%, 0.2);
        }
      }
    }
  }
}

@keyframes slideDown {
  from {
    height: 0;
  }
  to {
    height: vh(281);
  }
}

@keyframes slideUp {
  from {
    height: vh(281);
  }
  to {
    height: 0;
  }
}
</style>
